"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateMessageTemplateRequestSchema = exports.CreateMessageTemplateRequestSchema = exports.MessageTemplateListQuerySchema = exports.MessageTemplateIdPathParamsSchema = exports.MESSAGE_TEMPLATE_CONSTRAINTS = void 0;
const zod_1 = require("zod");
const schemas_1 = require("../../../../schemas");
exports.MESSAGE_TEMPLATE_CONSTRAINTS = {
    MESSAGE_MAX: 1500,
    MESSAGE_MIN: 1,
    NAME_MAX: 100,
    NAME_MIN: 1,
};
exports.MessageTemplateIdPathParamsSchema = zod_1.z.object({ templateId: schemas_1.UUIDSchema });
exports.MessageTemplateListQuerySchema = schemas_1.PaginationQuerySchema;
exports.CreateMessageTemplateRequestSchema = zod_1.z.object({
    message: zod_1.z
        .string()
        .min(exports.MESSAGE_TEMPLATE_CONSTRAINTS.MESSAGE_MIN)
        .max(exports.MESSAGE_TEMPLATE_CONSTRAINTS.MESSAGE_MAX),
    name: zod_1.z
        .string()
        .min(exports.MESSAGE_TEMPLATE_CONSTRAINTS.NAME_MIN)
        .max(exports.MESSAGE_TEMPLATE_CONSTRAINTS.NAME_MAX),
});
exports.UpdateMessageTemplateRequestSchema = exports.CreateMessageTemplateRequestSchema.partial();
